<template>
  <main class="w-full">
    <Header />
    <!--Container-->
    <div class="container w-full mx-auto pt-20">
      <div class="w-full px-4 md:px-0 md:mt-8 mb-16 text-gray-800 leading-normal">
        <!--Console Content-->

        <div class="flex flex-wrap">
          <div class="w-full md:w-1/2 xl:w-1/3 p-3">
            <!--Metric Card-->
            <div class="bg-white border rounded shadow p-2">
              <div class="flex flex-row items-center">
                <div class="flex-shrink pr-4">
                  <div class="rounded p-3 bg-green-600">
                    <i class="fa fa-wallet fa-2x fa-fw fa-inverse"></i>
                  </div>
                </div>
                <div class="flex-1 text-right md:text-center">
                  <h5 class="font-bold uppercase text-gray-500">Total Revenue</h5>
                  <h3 class="font-bold text-3xl">
                    $3249 <span class="text-green-500"><i class="fas fa-caret-up"></i></span>
                  </h3>
                </div>
              </div>
            </div>
            <!--/Metric Card-->
          </div>
          <div class="w-full md:w-1/2 xl:w-1/3 p-3">
            <!--Metric Card-->
            <div class="bg-white border rounded shadow p-2">
              <div class="flex flex-row items-center">
                <div class="flex-shrink pr-4">
                  <div class="rounded p-3 bg-orange-600">
                    <i class="fas fa-users fa-2x fa-fw fa-inverse"></i>
                  </div>
                </div>
                <div class="flex-1 text-right md:text-center">
                  <h5 class="font-bold uppercase text-gray-500">Total Users</h5>
                  <h3 class="font-bold text-3xl">
                    249 <span class="text-orange-500"><i class="fas fa-exchange-alt"></i></span>
                  </h3>
                </div>
              </div>
            </div>
            <!--/Metric Card-->
          </div>
          <div class="w-full md:w-1/2 xl:w-1/3 p-3">
            <!--Metric Card-->
            <div class="bg-white border rounded shadow p-2">
              <div class="flex flex-row items-center">
                <div class="flex-shrink pr-4">
                  <div class="rounded p-3 bg-yellow-600">
                    <i class="fas fa-user-plus fa-2x fa-fw fa-inverse"></i>
                  </div>
                </div>
                <div class="flex-1 text-right md:text-center">
                  <h5 class="font-bold uppercase text-gray-500">New Users</h5>
                  <h3 class="font-bold text-3xl">
                    2 <span class="text-yellow-600"><i class="fas fa-caret-up"></i></span>
                  </h3>
                </div>
              </div>
            </div>
            <!--/Metric Card-->
          </div>
          <div class="w-full md:w-1/2 xl:w-1/3 p-3">
            <!--Metric Card-->
            <div class="bg-white border rounded shadow p-2">
              <div class="flex flex-row items-center">
                <div class="flex-shrink pr-4">
                  <div class="rounded p-3 bg-blue-600">
                    <i class="fas fa-server fa-2x fa-fw fa-inverse"></i>
                  </div>
                </div>
                <div class="flex-1 text-right md:text-center">
                  <h5 class="font-bold uppercase text-gray-500">Server Uptime</h5>
                  <h3 class="font-bold text-3xl">152 days</h3>
                </div>
              </div>
            </div>
            <!--/Metric Card-->
          </div>
          <div class="w-full md:w-1/2 xl:w-1/3 p-3">
            <!--Metric Card-->
            <div class="bg-white border rounded shadow p-2">
              <div class="flex flex-row items-center">
                <div class="flex-shrink pr-4">
                  <div class="rounded p-3 bg-blue-600">
                    <i class="fas fa-tasks fa-2x fa-fw fa-inverse"></i>
                  </div>
                </div>
                <div class="flex-1 text-right md:text-center">
                  <h5 class="font-bold uppercase text-gray-500">To Do List</h5>
                  <h3 class="font-bold text-3xl">7 tasks</h3>
                </div>
              </div>
            </div>
            <!--/Metric Card-->
          </div>
          <div class="w-full md:w-1/2 xl:w-1/3 p-3">
            <!--Metric Card-->
            <div class="bg-white border rounded shadow p-2">
              <div class="flex flex-row items-center">
                <div class="flex-shrink pr-4">
                  <div class="rounded p-3 bg-red-600">
                    <i class="fas fa-inbox fa-2x fa-fw fa-inverse"></i>
                  </div>
                </div>
                <div class="flex-1 text-right md:text-center">
                  <h5 class="font-bold uppercase text-gray-500">Issues</h5>
                  <h3 class="font-bold text-3xl">
                    3 <span class="text-red-500"><i class="fas fa-caret-up"></i></span>
                  </h3>
                </div>
              </div>
            </div>
            <!--/Metric Card-->
          </div>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Header from "./components/Header";
export default {
  name: "dashboard-layout",
  components: {
    Header,
  },
  props: ["loggedIn"],
};
</script>

<style>
body {
  background-color: #e1e1e1;
}
.form-wrapper {
  border-radius: 7px;
}
.form-wrapper label {
  font-weight: bold;
}
.errors li {
  list-style: none;
  width: 100%;
  text-align: center;
}
.errors ul {
  padding-left: 0;
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .form-wrapper .text-right {
    text-align: center !important;
  }

  .form-wrapper .btn-primary {
    display: block;
    margin: 0 auto;
  }
}
</style>
